import React from 'react';

import { Title, Text, Box } from '@nerdwallet/currency';

import { useUrlRecordContext } from '../../../url-record';

import style from './page-title.module.less';

interface PageTitleProps {
  stateName: string;
  housingMarketSection: string;
}

const PageTitle: React.FC<PageTitleProps> = ({
  stateName,
  housingMarketSection,
}) => {
  const { title, synopsis } = useUrlRecordContext();

  return (
    <Box className={style.container} marginTop="3" marginBottom="4">
      <Title component="h1">{title}</Title>
      <Box marginTop="2" marginBottom="2">
        <Text>{synopsis}</Text>
      </Box>
      <Box marginBottom="2">
        <Text bold className={style.housingMarket}>
          {stateName} housing market
        </Text>
      </Box>
      <Box>
        <Text>{housingMarketSection}</Text>
      </Box>
    </Box>
  );
};

export default PageTitle;
